// import Vue from 'vue'
// import consts from "@/consts"
// import range from "lodash/range";
import {capitalizeFirstLetter, getApiProps, updateObjectByDiff} from "@/lib/lib";
import Promise from "lodash/_Promise";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';
const replaceTypeToFn = {
    'media_requests': 'VideoRequests',
}

// Built on every call and never cached: the array is also changed in place (splice on delete,
// push on a single update, sort in a getter) and nothing tells a cached map that it has gone stale.
function getUserFavoritesIndexMap(state) {
    return new Map(state.userFavorites.map((u, i) => [u.type, i]))
}
// const collator = new Intl.Collator();
// const sortByName = function (a, b) {
//     let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
//     if (cmp) {
//         return cmp;
//     }
//     return a.id - b.id;
// }

export default {
    state: {
        userFavoritesFullLoad: false,
        userFavoritesLiteLoad: false,
        userFavorites: [],
    },
    actions: {
        fetchUserFavorites/*all*/({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUserFavorites', args, time: Date.now() / 1000})

                const params = getApiProps('userFavorites', args)
                this.$api.userFavorites.getAll({...params})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        commit('setUserFavoritesLiteLoad', true)
                        commit('setUserFavoritesFullLoad', true)
                        dispatch('setLastCall', {name: 'fetchUserFavorites', args, inprogress: false})
                    });
            })
        },
        fetchUserFavoritesAndObjects({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchUserFavoritesAndObjects', args, time: Date.now() / 1000})

                dispatch('fetchUserFavorites')
                    .then((data) => {
                        commit('updateUserFavorites', data)
                        data.forEach(data => {
                            let fn = replaceTypeToFn[data.type] || data.type.split('_').map(srt => capitalizeFirstLetter(srt)).join('')
                            dispatch(`fetchFavorites${fn}`)
                        })
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchUserFavoritesAndObjects', args, inprogress: false})
                    });
            })
        },

        saveUserFavorite({dispatch}, userFavorite) {
            let fn = 'updateUserFavorite';//(userFavorite.id) ? 'updateUserFavorite' : 'createUserFavorite'
            return dispatch(fn, userFavorite);
        },

        updateUserFavorite({commit, getters}, userFavorite) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !userFavorite?.id || !userFavorite?.type) {
                    return reject(false);
                }
                const params = getApiProps('userFavorites')
                this.$api.userFavorites.update(userFavorite.id, userFavorite.type, userFavorite, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateUserFavorite', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteUserFavorite({getters, commit}, userFavorite) {//remove
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !userFavorite?.id || !userFavorite?.type) {
                    return reject(false);
                }
                const params = getApiProps('userFavorites')
                this.$api.userFavorites.delete(userFavorite.id, userFavorite.type, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (!response.data || !response.data.error) {
                            commit('updateUserFavorite', response.data)
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setUserFavoritesFullLoad(state, FullLoad) {
            state.userFavoritesFullLoad = state.userFavoritesFullLoad || FullLoad
        },
        setUserFavoritesLiteLoad(state, LitaLoad) {
            state.userFavoritesLiteLoad = state.userFavoritesLiteLoad || LitaLoad
        },

        setUserFavorites(state, nUserFavorites) {
            // nUserFavorites = nUserFavorites.map(u => {
            //     if (u?.name) u.name_ = u.name.toLocaleLowerCase()
            //     return u //Object.freeze(u)
            // })
            //nUserFavorites.sort(sortByName)
            state.userFavorites = nUserFavorites
        },

        updateUserFavorites(state, nUserFavorites) {
            if (!state.userFavorites.length) {
                // nUserFavorites = nUserFavorites.map(u => {
                //     if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                //     return u //Object.freeze(u)
                // })
                //nUserFavorites.sort(sortByName)
                state.userFavorites = nUserFavorites
                // const chunks = arraySplitIntoChunks(nUserFavorites)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.userFavorites.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            const indexByType = getUserFavoritesIndexMap(state)
            nUserFavorites.forEach(function (nUserFavorite) {
                if (nUserFavorite?.name) nUserFavorite.name_ = nUserFavorite.name.toLocaleLowerCase()
                let i = indexByType.has(nUserFavorite.type) ? indexByType.get(nUserFavorite.type) : -1
                if (i < 0) {
                    indexByType.set(nUserFavorite.type, state.userFavorites.length)
                    state.userFavorites.push(nUserFavorite) //(Object.freeze(nUserFavorite))
                } else
                if (!state.userFavoritesFullLoad || state.userFavorites[i][changedField] != nUserFavorite[changedField]) {
                    updateObjectByDiff(state.userFavorites[i], nUserFavorite)
                    // delete nUserFavorite.userFavoriteId
                    // nUserFavorite = {...state.userFavorites[i], ...nUserFavorite}
                    // state.userFavorites[i] = nUserFavorite //Object.freeze(nUserFavorite)
                }
            })

        },
        updateUserFavorite(state, nUserFavorite) {
            if (nUserFavorite?.name) nUserFavorite.name_ = nUserFavorite.name.toLocaleLowerCase()
            let i = state.userFavorites.findIndex(u => (u.type == nUserFavorite.type))
            if (i < 0) {
                state.userFavorites.push(nUserFavorite) //(Object.freeze(nUserFavorite))
            } else
            //if (!state.userFavoritesFullLoad || state.userFavorites[i][changedField] != nUserFavorite[changedField])
            {
                updateObjectByDiff(state.userFavorites[i], nUserFavorite)
                // delete nUserFavorite.userFavoriteId
                // nUserFavorite = {...state.userFavorites[i], ...nUserFavorite}
                // state.userFavorites[i] = nUserFavorite //Object.freeze(nUserFavorite)
            }
        },

        clearUserFavorites(state) {
            state.userFavorites = []
            state.userFavoritesFullLoad = false
            state.userFavoritesLiteLoad = false
        },
    },
    getters: {
        isUserFavoritesFullLoad(state) {
            return state.userFavoritesFullLoad
        },
        isUserFavoritesLiteLoad(state) {
            return state.userFavoritesLiteLoad
        },
        getUserFavorites(state) {
            return state.userFavorites
        },
        getUserFavoritesByType(state) {
            return state.userFavorites
                .reduce((userFavoritesByIds, userFavorite) => {
                    userFavoritesByIds[userFavorite.type] = userFavorite
                    return userFavoritesByIds
                }, {})
        },
    }
}
